export const getNestedValue = (obj: any, path: string) => path.split(".").reduce((acc, part) => (acc ? acc[part] : undefined), obj);

export const createEmptyItem = (fields: any[], groupName: string): Record<string, any> => {
  return fields
    .filter((f) => f.group === groupName)
    .reduce((acc, field) => {
      if (field.isMultiField) {
        return acc;
      }

      let defaultValue: any = "";
      if (field.type === "number") defaultValue = 0;
      else if (field.type === "checkbox") defaultValue = false;

      const fieldName = field.name.includes(`${groupName}.`) ? field.name.split(".").slice(1).join(".") : field.name;
      acc[fieldName] = defaultValue;
      return acc;
    }, {} as Record<string, any>);
};

export const hasFieldArrayError = (errors: any, arrayName: string, index: number, fieldName: string) =>
  Boolean((errors[arrayName] as any)?.[index]?.[fieldName]);
